class FornivioBuybar extends HTMLElement {
 connectedCallback() {
  this.main = document.getElementById('main-content');
  this.price = this.querySelector('[data-fv-price]');
  this.button = this.querySelector('[data-fv-buy]');
  this.onBuy = () => {
   const host = document.querySelector('[data-product-form]');
   const form = host?.querySelector('form');
   const submitter = form?.querySelector('button[name="return_to"]');
   if (form && submitter && !submitter.disabled) form.requestSubmit(submitter);
   else host?.scrollIntoView({behavior:'smooth',block:'start'});
  };
  this.sync = () => {
   const host = document.querySelector('[data-product-form]');
   const value = host?.querySelector('[data-fv-current-price]')?.textContent.trim();
   if (value && this.price.textContent !== value) this.price.textContent = value;
   const canBuy = Boolean(host?.querySelector('button[name="return_to"]:not([disabled])'));
   this.button.disabled = !canBuy;
   const label = canBuy ? this.button.dataset.buyLabel : this.button.dataset.unavailableLabel;
   if (this.button.textContent !== label) this.button.textContent = label;
   if (this.purchaseHost !== host && host) {
    this.intersection?.disconnect();
    this.purchaseHost = host;
    this.intersection = new IntersectionObserver(entries => {
     const entry = entries[0];
     this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
    });
    this.intersection.observe(host);
   }
  };
  this.button.addEventListener('click', this.onBuy);
  this.observer = new MutationObserver(this.sync);
  if (this.main) this.observer.observe(this.main, {childList:true,subtree:true});
  this.sync();
 }
 disconnectedCallback() {
  this.observer?.disconnect();
  this.intersection?.disconnect();
  this.button?.removeEventListener('click', this.onBuy);
 }
}
if (!customElements.get('fornivio-buybar')) customElements.define('fornivio-buybar', FornivioBuybar);